import React from 'react';
import classes from './BankLoanBanner.module.css';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../Button/Button';
import { BankLoanImage } from '../../constant/imagePath';
import { useNavigate } from 'react-router-dom';

function BankLoanBanner({ containerClass = '', t }) {
  const navigate = useNavigate();
  return (
    <Container className={[containerClass, classes.banner].join(' ')}>
      <Row>
        <Col md={6}>
          <div className={classes.imgDiv}>
            <img alt="bank-loan-banner" src={BankLoanImage} />
          </div>
        </Col>
        <Col md={6}>
          <div className={classes.aCenter}>
            <h6>{t('bannerData.title')}</h6>
            <p>{t('bannerData.description')}</p>
            <Button
              borderRadius={'8px'}
              variant="primary"
              onClick={() => navigate(`/mortgage-bank-loan`)}>
              {t('bannerData.buttonData')}
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default BankLoanBanner;
